export const SOLVED_COMPLAIN = "SOLVED_COMPLAIN";

export const OPEN_COMPLAIN_DIALOG = "OPEN_COMPLAIN_DIALOG";
export const CLOSE_COMPLAIN_DIALOG = "CLOSE_COMPLAIN_DIALOG";

export const GET_COMPLAIN = "GET_COMPLAIN";

export const GET_AGENCY_TOTAL_COMPLAIN = "GET_AGENCY_TOTAL_COMPLAIN";
